// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import hearingStatusEntity from './entities/hearing-status.json';
import hearingStatusMenu from '../pages/hearing-status/menu.json';
import hearingStatusFullForm from '../pages/hearing-status/forms/full.json';
import hearingStatusContextForm from '../pages/hearing-status/forms/context.json';
import hearingStatusMiniForm from '../pages/hearing-status/forms/mini.json';
import hearingStatusLookupForm from '../pages/hearing-status/forms/lookup.json';
import hearingStatusTableView from '../pages/hearing-status/views/table.json';
import hearingStatusDashboardView from '../pages/hearing-status/views/dashboard.json';

/** Тип запису «Статус слухань» зі сторінками пакета: меню, форми та подання з pages/hearing-status/. */
export const hearingStatusDefinition: IRecordTypeDefinition = {
  ...hearingStatusEntity,
  views: assembleViewSet({
      table: hearingStatusTableView,
      dashboard: hearingStatusDashboardView,
  }),
  form: hearingStatusFullForm,
  forms: { full: hearingStatusFullForm, context: hearingStatusContextForm, mini: hearingStatusMiniForm, lookup: hearingStatusLookupForm },
  menu: hearingStatusMenu,
} as IRecordTypeDefinition;
